/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PaymentAccount/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import InsurancePaymentAccount from './InsurancePaymentAccount/index'
import No from './No/index'
import PersonPaymentAccount from './PersonPaymentAccount/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function PaymentAccount({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsCreatePaymentPlanForExistingInvoice/Content/Content/SourceInvoice/PaymentAccount"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let receivablePaymentAccountAccountTypeValueData = fromData.useDataValue({ viewPath,
context: 'receivable',
path: 'payment_account.account_type',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: receivablePaymentAccountAccountTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'InsurancePaymentAccount'}>
<InsurancePaymentAccount
  viewPath={`${viewPath}/InsurancePaymentAccount`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PersonPaymentAccount'}>
<PersonPaymentAccount
  viewPath={`${viewPath}/PersonPaymentAccount`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}